import React, { useEffect, useState } from "react";

/**Import Styles and Assets */
import styles from "./PostManagement.module.scss";
import back from "./images/back.svg"

import { usePostListingHeader, usePostManagementHeader } from "../../schemas/tableHeaderSchema";
import TableLayout from "../../components/TableLayout";
import { useDispatch, useSelector } from "react-redux";
import { fetchUserPostThunk } from "../../features/PostManagementReducer";
import FileReaderModal from "../../components/Modal/FileReaderModal";



export default function PostManagement() {

    const { data, status } = useSelector(state => state.postManagement);
    const { search } = useSelector(state => state.search);
    const [list, setList] = useState(data);
    const dispatch = useDispatch();

    const [isListed, setIsListed] = useState(true);
    const [userPostList, setUserPostList] = useState([])
    const [postList, setPostList] = useState(userPostList);
    const [file, setFile] = useState({
        path: "",
        type: ""
    });

    const soundTrackHeader = usePostManagementHeader(setIsListed, setUserPostList);
    const listingHeader = usePostListingHeader(setUserPostList, setFile);

    useEffect(() => {
        if (status !== "success") {
            dispatch(fetchUserPostThunk());
        }
    }, [])

    useEffect(() => {
        if (!search) return setList(data);


        const array = [
            ...data.map(item => {
                if (item.username.toLowerCase().includes(search.toLowerCase())) {
                    return item
                }
            })
        ].filter(Boolean)
        setList(array);

    }, [data, search])

    useEffect(() => {
        if (!search) return setPostList(userPostList);


        const array = [
            ...userPostList.map(item => {
                if (item.description.toLowerCase().includes(search.toLowerCase())) {
                    return item
                }
            })
        ].filter(Boolean)
        setPostList(array);

    }, [search, userPostList])

    function handleClose() {
        setFile({
            path: "",
            type: "",
        })
    }




    return isListed ?
        <div className={styles.postManagement} >
            <h1 className={styles.contentTitle}>Post Management</h1>
            <div className={styles.content}>
                <TableLayout headers={soundTrackHeader} data={list} status={status} />
            </div>
        </div > :
        <div className={styles.postManagement} >
            <div onClick={() => setIsListed(true)} className={styles.backButton}>
                <img src={back} alt="<" />
                <h1 className={styles.backButton} >Back</h1>
            </div>
            <div className={styles.content}>
                {file.path ? <FileReaderModal {...{ ...file, handleClose }} /> : ""}
                <TableLayout headers={listingHeader} data={postList} status={"success"} />
            </div>
        </div >





}